import PropTypes from 'prop-types'
import AdventureReviewRating from './AdventureReviewRating'
import styles from './AdventureSingleReview.module.scss'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import { FormattedMessage } from 'react-intl'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

export default function AdventureSingleReview({ review }) {
  const { rating, deepLink, publishDatetime, text } = review

  return (
    <div className={styles.reviewContainer}>
      <div className={styles.reviewHeader}>
        <AdventureReviewRating
          rating={rating}
          className={styles.smallerStars}
        />
        <span>{dayjs(publishDatetime).fromNow()}</span>
        {deepLink && (
          <a href={deepLink} target='_blank' rel='noreferrer noopener'>
            <FormattedMessage defaultMessage='Google Review' />
          </a>
        )}
      </div>
      <div className={styles.reviewText}>{text}</div>
    </div>
  )
}

AdventureSingleReview.propTypes = {
  review: PropTypes.object.isRequired,
}
